import { LimitTypography } from '@aibees/elephant/components/limit-typography';
import { useCompanyReadDataContext } from '@aibees/elephant/context';
import { classnames } from '@aibees/shared/utils';
import { Box, Divider, Skeleton, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import type { CompanySeoDescriptionProps as Props } from './types';

export const CompanySeoDescription = memo(
  ({ className, sx, isDetailPopover, data }: Props) => {
    const { api } = useCompanyReadDataContext();
    const sourceData = isDetailPopover ? data : api?.data;
    const description = sourceData?.summary?.seo;

    return (
      <>
        <Styled.Wrapper
          className={classnames('CompanySeoDescription', className)}
          sx={sx}
        >
          <Typography variant="body3" color="grey.700" fontWeight="bold">
            SEO Description:
          </Typography>
          {api?.isFetching ? (
            <Skeleton animation="wave" variant="rounded" />
          ) : (
            <>
              {description && (
                <Box>
                  <LimitTypography
                    value={description}
                    wordLimit={isDetailPopover ? 14 : 20}
                    fontWeight={400}
                    variant="body4"
                  />
                </Box>
              )}
              {!description && (
                <Typography variant="body4" color="grey.400">
                  No information is available.
                </Typography>
              )}
            </>
          )}
        </Styled.Wrapper>
        <Divider />
      </>
    );
  }
);

CompanySeoDescription.displayName = 'CompanySeoDescription';
